export enum FilterMemberType {
  ALL_CLIENTS = 'all_clients',
  WELLNITE_MEMBERS = 'wellnite_members',
  DP_CLIENTS = 'dp_clients',
}

export enum FilterPaymentType {
  ALL = 'all',
  INSURANCE = 'insurance',
  CASH = 'cash',
}
